/* Fann Bliss: catalogue grid (sections/fann-catalog.liquid) and the sliding chip rows of the shop pages.
   The first step of cards is rendered by the server, in the same order this script uses. The script then reads the
   whole source collection from sections/fann-catalog-feed.liquid (Section Rendering API, 250 a page) and takes over:
   type chips (mug, tumbler, bottle, coaster) on mixed pages, theme chips with a second row (Countries > Europe, Asia…)
   where the "Theme chips" setting lists them for the collection, shop-by chips (grown-ups, kids, lid) on pages of one
   kind, size chips read from the titles, search, price bands, sort and "Show more" in steps.
   Colour versions of one design ("Japan Mug Teal – 320ml", "Japan Mug – 320ml") share a card with colour dots.
   Featured order: blanks first (never on the all-products page), then the product types in data-lead, then the rest;
   with mixing on, cards take turns by theme (or by product type on a page without themes).
   On phones the chip row docks under the header and the size, price and sort controls open as a panel from the
   bottom. Filters live in the address (?type=&theme=&sub=&view=&size=&price=&sort=&q=) so a view can be shared.
   Every sliding row ([data-fh-scroller], here and in the collection hero) shows fades and arrows on the sides it can
   move to, snaps to its chips, and nudges once per visit so it reads as scrollable.
   Add buttons are handled by fann-home.js ([data-fh-add]). */
(function () {
  'use strict';
  if (window.__fhCatalog) return;
  window.__fhCatalog = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICON = {
    bag: '<path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    brush: '<path d="M14 3l7 7-8 8-7-7z"/><path d="M6 11c-2.5 2.5-3 5-3 8 3 0 5.5-.5 8-3"/>',
    sparkle: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z"/>'
  };
  function ic(n) { return '<svg class="fh-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICON[n] || '') + '</svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var FH = window.FannHome;
    if (FH && FH.money) return FH.money(c);
    var a = c / 100; return 'AED ' + (a % 1 === 0 ? a : a.toFixed(2));
  }
  function slug(s) { return String(s).toLowerCase().replace(/['"’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function fam(it) {
    var h = ((it.ty || '') + ' ' + it.t).toLowerCase();
    return h.indexOf('coaster') > -1 ? 'coaster' : h.indexOf('mug') > -1 ? 'mug' : h.indexOf('tumbler') > -1 ? 'tumbler' : h.indexOf('bottle') > -1 ? 'bottle' : 'other';
  }
  function sizes(t) {
    var m = String(t).match(/(\d{3,4})\s*(?:ml)?\s*(?:&|and|\/)\s*(\d{3,4})\s*ml/i) || String(t).match(/(\d{3,4})\s*ml/i);
    if (!m) return [];
    return m[2] ? [m[1], m[2]] : [m[1]];
  }
  /* "Stitch Fun Bottle 500 & 720ML" -> name "Stitch Fun Bottle", spec "500 & 720ml". Mirrors snippets/fann-ccard. */
  function split(t, blank) {
    t = String(t).split(' | ')[0].trim();
    if (blank) t = t.replace(/^Custom\s+/, '');
    var name = t, spec = '';
    if (t.indexOf(' – ') > -1) { name = t.split(' – ')[0].trim(); spec = t.slice(t.indexOf(' – ') + 3).trim(); }
    else {
      var w = t.split(' '), cut = -1;
      for (var i = 0; i < w.length; i++) {
        var n = parseInt(w[i].toLowerCase().replace('ml', ''), 10);
        if (n >= 100 && n <= 2000) {
          var nx = (w[i + 1] || '').toLowerCase();
          if (/ml/i.test(w[i]) || nx === '&' || nx === 'and' || nx === '/') { cut = i; break; }
        }
      }
      if (cut > 0) { name = w.slice(0, cut).join(' '); spec = w.slice(cut).join(' '); }
      else if (cut === 0 && t.indexOf(' with ') > 0) { name = t.slice(0, t.indexOf(' with ')); spec = t.slice(t.indexOf(' with ') + 6); }
    }
    return { name: name, spec: spec.replace(/ with /g, ' · ').replace(/ML/g, 'ml') };
  }
  function sized(u, w) { return u ? u.replace(/([?&])width=\d+/, '$1width=' + w) : ''; }

  /* ---------------------------------------------------------------- colour versions (mirrors the section) */
  var COLW = ['purple', 'teal', 'pink', 'yellow', 'red', 'green', 'blue', 'orange', 'black', 'white', 'grey', 'gray', 'navy', 'lilac', 'gold', 'silver'];
  var COLS = ['light-purple', 'light-blue', 'light-green', 'light-pink', 'dark-green', 'dark-blue'].concat(COLW);
  /* "Australia Mug Purple – 320ml" -> key "mug~australia mug~320ml", colour "purple". The colour comes from the
     title, then a colour tag, then the handle; without one it is the design's own (base) version. */
  function vkey(it) {
    var t = String(it.t).split(' | ')[0].trim(), nm = t, rest = '';
    if (t.indexOf(' – ') > -1) { nm = t.split(' – ')[0]; rest = t.slice(nm.length).replace(' – ', '').trim(); }
    var w = nm.trim().split(/\s+/), keep = w.length, cw = '';
    for (var j = w.length - 1; j >= 0; j--) {
      if (keep < 2) break;
      var wl = w[j].toLowerCase();
      if (COLW.indexOf(wl) > -1) { cw = cw ? wl + '-' + cw : wl; keep--; }
      else { if (cw && (wl === 'light' || wl === 'dark')) { cw = wl + '-' + cw; keep--; } break; }
    }
    var k = (it.fam + '~' + w.slice(0, keep).join(' ') + '~' + rest).toLowerCase().replace(/[\^=]/g, '');
    if (!cw) for (var a = 0; a < COLS.length; a++) if (it.ts.indexOf('|' + COLS[a] + '|') > -1) { cw = COLS[a]; break; }
    if (!cw) { var hs = '-' + it.h + '-'; for (var b = 0; b < COLS.length; b++) if (hs.indexOf('-' + COLS[b] + '-') > -1) { cw = COLS[b]; break; } }
    return { k: k, c: cw || 'base' };
  }
  /* the card's name without its colour: "Japan Mug Teal" -> "Japan Mug". Mirrors snippets/fann-ccard. */
  function stripCol(n) {
    var w = String(n).trim().split(/\s+/), keep = w.length, got = false;
    for (var j = w.length - 1; j >= 0; j--) {
      if (keep < 2) break;
      var wl = w[j].toLowerCase();
      if (COLW.indexOf(wl) > -1) { got = true; keep--; }
      else { if (got && (wl === 'light' || wl === 'dark')) keep--; break; }
    }
    return w.slice(0, keep).join(' ');
  }

  /* ---------------------------------------------------------------- theme chips (mirrors the section) */
  function parseThemes(raw, handle) {
    var top = [], subs = [];
    String(raw || '').split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (line.indexOf(': ') < 0 || line.indexOf(' = ') < 0) return;
      var hraw = line.split(': ')[0], hk = ',' + hraw.toLowerCase().replace(/ /g, '') + ',';
      if (hk.indexOf(',' + handle + ',') < 0 && hk !== ',*,') return;
      var body = line.slice(hraw.length + 1).trim(), parts = body.split(' = ');
      var name = parts[0].trim(), spec = parts[parts.length - 1];
      var sp = spec.split(' | '), rules = sp[0].split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var icon = spec.indexOf(' | ') > -1 ? sp[sp.length - 1].trim() : '';
      if (name.indexOf(' > ') > -1) { subs.push({ p: name.split(' > ')[0].trim().toLowerCase(), n: name.split(' > ').slice(1).join(' > ').trim(), rules: rules }); return; }
      if (top.length >= 9) return;
      top.push({ n: name, slug: slug(name), ic: icon, rules: rules, subs: [] });
    });
    subs.forEach(function (s) {
      var par = top.filter(function (t) { return t.n.toLowerCase() === s.p; })[0];
      if (par) par.subs.push({ n: s.n, slug: slug(s.n), rules: s.rules });
    });
    return top;
  }
  function hit(it, rules) {
    for (var i = 0; i < rules.length; i++) {
      var tk = rules[i].trim().toLowerCase(), v;
      if (tk === 'rest') return true;
      if (tk === 'name') { if (it.n) return true; }
      else if (tk === 'new') { if (it.w) return true; }
      else if (tk.slice(0, 4) === 'tag:') { v = tk.slice(4).trim(); if (it.ts.indexOf('|' + v + '|') > -1) return true; }
      else if (tk.slice(0, 6) === 'title:') { v = tk.slice(6).trim(); if (v && it.t.toLowerCase().indexOf(v) > -1) return true; }
      else if (tk.slice(0, 5) === 'type:') { v = tk.slice(5).trim(); if (v && String(it.ty || '').toLowerCase().indexOf(v) > -1) return true; }
    }
    return false;
  }

  function card(it, T, g, sel, gi) {
    var many = g && g.vs.length > 1, nm = split(it.t, it.b), url = esc(it.u), tag = '';
    if (it.b) tag = '<span class="fh-cc-tag fh-cc-tag--blank">' + ic('brush') + esc(T.blankTag) + '</span>';
    else if (it.n) tag = '<span class="fh-cc-tag fh-cc-tag--name">' + ic('brush') + esc(T.nameTag) + '</span>';
    if (it.w && !it.b) tag += '<span class="fh-cc-tag fh-cc-tag--new">' + ic('sparkle') + esc(T.newTag || 'New') + '</span>';
    if (it.c) tag += '<span class="fh-cc-tag fh-cc-tag--sale">' + esc(T.saleTag) + '</span>';
    var img = it.i ? '<img src="' + esc(sized(it.i, 450)) + '" srcset="' + esc(sized(it.i, 300)) + ' 300w, ' + esc(sized(it.i, 450)) + ' 450w, ' + esc(it.i) + ' 600w" sizes="(min-width: 1100px) 270px, (min-width: 640px) 31vw, 46vw" alt="" loading="lazy" decoding="async">' : '';
    var btn = it.b ? '<a class="fh-cc-btn fh-cc-btn--pz" href="' + url + '">' + ic('brush') + esc(T.pz) + '</a>'
      : it.m ? '<a class="fh-cc-btn" href="' + url + '" aria-label="' + esc(T.choose + ' ' + it.t) + '">' + esc(T.choose) + '</a>'
      : '<button type="button" class="fh-cc-btn" data-fh-add="' + it.v + '" data-fh-label="' + esc(it.t) + '" aria-label="' + esc(T.cta + ' ' + it.t) + '">' + ic('bag') + esc(T.cta) + '</button>';
    var dots = '';
    if (many) {
      dots = '<div class="fh-cc-dots" role="group" aria-label="' + esc(T.colours || 'Colours') + '">' + g.vs.map(function (m, j) {
        var l = m.vc === 'base' ? (T.base || 'Classic') : m.vc.replace(/-/g, ' ');
        l = l.charAt(0).toUpperCase() + l.slice(1).toLowerCase();
        return '<button type="button" class="fh-cc-dot" data-fh-dot="' + j + '" data-c="' + esc(m.vc) + '" aria-pressed="' + (j === sel ? 'true' : 'false') + '" aria-label="' + esc(l) + '"></button>';
      }).join('') + '</div>';
    }
    return '<article class="fh-cc' + (it.k ? ' fh-cc--cut' : '') + '" data-fam="' + it.fam + '"' + (gi != null ? ' data-g="' + gi + '"' : '') + '>' +
      '<a class="fh-cc-media" href="' + url + '" tabindex="-1" aria-hidden="true">' + img + '<span class="fh-cc-tags">' + tag + '</span></a>' +
      '<div class="fh-cc-body"><a class="fh-cc-name" href="' + url + '">' + esc(many ? stripCol(nm.name) : nm.name) + (nm.spec ? '<span>' + esc(nm.spec) + '</span>' : '') + '</a>' + dots +
      '<div class="fh-cc-row"><span class="fh-cc-price">' + (it.f ? '<small>' + esc(T.from) + '</small> ' : '') + esc(money(it.p)) + (it.c ? ' <s>' + esc(money(it.c)) + '</s>' : '') + '</span>' + btn + '</div></div></article>';
  }

  /* shop-by chips: who it is for first, then the lid */
  var VIEWS = [['a:adult', 'user'], ['a:kids', 'school'], ['s:magsafe', 'magnet'], ['s:freesip', 'straw'], ['s:pop', 'bottle'], ['s:spout', 'drop'], ['s:straw', 'straw'], ['s:handlelid', 'tumbler'], ['s:handle', 'cup'], ['s:classic', 'tumbler']];
  function inView(it, v) {
    if (!v) return true;
    var k = v.slice(2);
    if (v.charAt(0) === 'a') return k === 'kids' ? (it.g === 1 || it.g === 2) : (it.g === 0 || it.g === 2);
    return it.l === k;
  }

  /* the header that sticks to the top of the window, so the chip row can dock right under it */
  function headerBottom() {
    var b = 0;
    $$('[class*="section-group-header"], .header-sticky, sticky-header').forEach(function (el) {
      var p = getComputedStyle(el).position;
      if (p !== 'sticky' && p !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > b && r.height < innerHeight / 2) b = r.bottom;
    });
    return Math.max(0, Math.round(b));
  }

  /* ---------------------------------------------------------------- sliding rows
     [data-fh-scroller] holds a [data-fh-track] that scrolls sideways and two arrow buttons. The sides it can move to
     fade out and show an arrow; the first time a row comes into view in a visit it slides a little and back. */
  function scroller(el) {
    if (el.__fhSc) return;
    var tr = $('[data-fh-track]', el); if (!tr) return;
    el.__fhSc = true;
    var kind = el.getAttribute('data-fh-scroller') || 'row', raf = 0, stop = false;
    function sync() {
      raf = 0;
      var max = tr.scrollWidth - tr.clientWidth, over = max > 4 && tr.offsetParent !== null;
      el.classList.toggle('is-over', over);
      el.classList.toggle('can-l', over && tr.scrollLeft > 4);
      el.classList.toggle('can-r', over && tr.scrollLeft < max - 4);
    }
    function q() { if (!raf) raf = requestAnimationFrame(sync); }
    tr.addEventListener('scroll', q, { passive: true });
    window.addEventListener('resize', q);
    if (window.ResizeObserver) new ResizeObserver(q).observe(tr);
    if (window.MutationObserver) new MutationObserver(q).observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(q);
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fh-sdir]'); if (!b) return;
      stop = true;
      tr.scrollBy({ left: +b.getAttribute('data-fh-sdir') * Math.max(140, tr.clientWidth * 0.7), behavior: reduce ? 'auto' : 'smooth' });
    });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { tr.addEventListener(ev, function () { stop = true; }, { passive: true }); });
    sync();

    /* the nudge: once per visit for each kind of row, never with reduced motion */
    var KEY = 'fh-nudge-' + kind;
    function done() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return true; } }
    function nudge() {
      if (reduce || stop || done()) return;
      var max = tr.scrollWidth - tr.clientWidth; if (max < 24 || tr.offsetParent === null) return;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      var from = tr.scrollLeft, dir = from < max - 8 ? 1 : -1, dist = dir * Math.min(72, dir > 0 ? max - from : from);
      var snap = tr.style.scrollSnapType, t0 = 0, D1 = 480, HOLD = 160, D2 = 620;
      tr.style.scrollSnapType = 'none';
      function out(x) { return 1 - Math.pow(1 - x, 3); }
      function io(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
      function end() { tr.style.scrollSnapType = snap; q(); }
      function step(now) {
        if (!t0) t0 = now;
        if (stop) { end(); return; }
        var t = now - t0, x;
        if (t < D1) x = out(t / D1);
        else if (t < D1 + HOLD) x = 1;
        else if (t < D1 + HOLD + D2) x = 1 - io((t - D1 - HOLD) / D2);
        else { tr.scrollLeft = from; end(); return; }
        tr.scrollLeft = from + dist * x;
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!reduce && 'IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || en.intersectionRatio < 0.9) return;
          seen.disconnect(); setTimeout(nudge, 700);
        });
      }, { threshold: [0.9], rootMargin: '0px 0px -18% 0px' }); /* well inside the screen, not peeking at the bottom */
      seen.observe(tr);
    }
  }

  function init(sec) {
    if (sec.__fhCat) return; sec.__fhCat = true;
    var T = {}; try { T = JSON.parse($('[data-fh-catcfg]', sec).textContent); } catch (e) {}
    var VL = T.views || {};
    var src = sec.getAttribute('data-src') || '/collections/all';
    var handle = sec.getAttribute('data-handle') || src.replace(/\/$/, '').split('/').pop();
    var per = parseInt(sec.getAttribute('data-per'), 10) || 24;
    var hideBlanks = sec.getAttribute('data-hide-blanks') === '1', mix = sec.getAttribute('data-mix') === '1';
    var blanksFirst = sec.getAttribute('data-blanks-first') === '1', grp = sec.getAttribute('data-group') === '1';
    var LEAD = (sec.getAttribute('data-lead') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var grid = $('[data-fh-grid]', sec), typesEl = $('[data-fh-types]', sec), viewsEl = $('[data-fh-views]', sec);
    var themesEl = $('[data-fh-themes]', sec), subsEl = $('[data-fh-subs]', sec), subWrap = $('[data-fh-subwrap]', sec);
    var TH = themesEl && subsEl ? parseThemes(T.themes, handle) : [];
    var sizesEl = $('[data-fh-sizes]', sec), sizeWrap = $('[data-fh-sizewrap]', sec);
    var qEl = $('[data-fh-q]', sec), priceEl = $('[data-fh-price]', sec), sortEl = $('[data-fh-sort]', sec);
    var statusEl = $('[data-fh-status]', sec), clears = $$('[data-fh-clear]', sec), emptyEl = $('[data-fh-empty]', sec);
    var moreWrap = $('[data-fh-morewrap]', sec), moreBtn = $('[data-fh-more]', sec), meter = $('[data-fh-meter]', sec);
    var ftog = $('[data-fh-ftoggle]', sec), fcount = $('[data-fh-fcount]', sec), panel = $('[data-fh-filters]', sec);
    var scrim = $('[data-fh-scrim]', sec), fdone = $('[data-fh-fdone]', sec), fclose = $('[data-fh-fclose]', sec);
    var dock = $('[data-fh-dock]', sec), rowEl = $('[data-fh-row]', sec);
    var phone = window.matchMedia ? matchMedia('(max-width: 899px)') : { matches: false };
    var ICS = {}; $$('[data-k]', $('[data-fh-ics]', sec) ? $('[data-fh-ics]', sec).content : sec).forEach(function (i) { ICS[i.getAttribute('data-k')] = i.innerHTML; });

    var items = null, list = [], shown = 0, famOrder = [];
    var st = { type: 'all', theme: '', sub: '', view: '', size: '', price: '', sort: 'featured', q: '' };
    var KEYS = ['type', 'theme', 'sub', 'view', 'size', 'price', 'sort', 'q'];
    try {
      var sp = new URLSearchParams(location.search);
      KEYS.forEach(function (k) { if (sp.get(k)) st[k] = sp.get(k); });
    } catch (e) {}

    /* price bands from the steps setting, e.g. "50, 80, 100" -> under 50 / 50-80 / 80-100 / 100 and up */
    var steps = String(T.steps || '50, 80, 100').split(',').map(function (x) { return parseFloat(x); }).filter(function (x) { return x > 0; }).sort(function (a, b) { return a - b; });
    var bands = [];
    steps.forEach(function (v, i) { bands.push(i === 0 ? { k: '0-' + v, lo: 0, hi: v, l: (T.under || 'Under [x]').replace('[x]', money(v * 100)) } : { k: steps[i - 1] + '-' + v, lo: steps[i - 1], hi: v, l: (T.between || '[x] – [y]').replace('[x]', money(steps[i - 1] * 100)).replace('[y]', money(v * 100)) }); });
    if (steps.length) { var top = steps[steps.length - 1]; bands.push({ k: top + '-', lo: top, hi: Infinity, l: (T.over || '[x] and up').replace('[x]', money(top * 100)) }); }
    bands.forEach(function (b) { var o = document.createElement('option'); o.value = b.k; o.textContent = b.l; priceEl.appendChild(o); });
    priceEl.value = st.price; if (priceEl.value !== st.price) st.price = '';
    sortEl.value = st.sort; if (sortEl.value !== st.sort) st.sort = 'featured';
    qEl.value = st.q;

    function syncUrl() {
      try {
        var u = new URL(location.href);
        KEYS.forEach(function (k) {
          var v = st[k], def = k === 'type' ? 'all' : k === 'sort' ? 'featured' : '';
          if (v && v !== def) u.searchParams.set(k, v); else u.searchParams.delete(k);
        });
        u.searchParams.delete('page');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }
    function active() { return st.type !== 'all' || st.theme || st.view || st.size || st.price || st.q; }

    function inBand(it) {
      if (!st.price) return true;
      var b = bands.filter(function (x) { return x.k === st.price; })[0]; if (!b) return true;
      var a = it.p / 100; return a >= b.lo && a < b.hi;
    }
    function base() { /* everything but the chips: used for their counts */
      var q = st.q.trim().toLowerCase();
      return items.filter(function (it) {
        if (st.size && it.sz.indexOf(st.size) === -1) return false;
        if (!inBand(it)) return false;
        if (q && it.t.toLowerCase().indexOf(q) === -1 && (it.ty || '').toLowerCase().indexOf(q) === -1) return false;
        return true;
      });
    }
    function gkey(it) { return grp ? it.vk : '#' + it.i0; }
    /* how many cards a set of products makes */
    function ncards(arr) { var s = {}, n = 0; arr.forEach(function (it) { var k = gkey(it); if (!s[k]) { s[k] = 1; n++; } }); return n; }
    /* one card per colour group; its own (base) version leads, the rest follow in collection order */
    function groups(arr) {
      var by = {}, out = [];
      arr.forEach(function (it) {
        var k = gkey(it), g = by[k];
        if (!g) { g = by[k] = { vs: [], i0: it.i0, rk: it.rk, tix: it.tix, six: it.six, fi: it.fi, sel: 0 }; out.push(g); }
        g.vs.push(it);
      });
      out.forEach(function (g) {
        var b = g.vs.filter(function (m) { return m.vc === 'base'; })[0] || g.vs[0];
        if (b !== g.vs[0]) g.vs = [b].concat(g.vs.filter(function (m) { return m !== b; }));
        g.it = b;
      });
      return out;
    }
    /* Featured: by rank, then (mixing) cards take turns by bucket; blanks stay first. Mirrors the section. */
    function arrange(gs, bucket, nb) {
      gs.sort(function (a, b) { return a.rk - b.rk || a.i0 - b.i0; });
      if (!bucket || nb < 2) return gs;
      var head = [], rest = [], cnt = {};
      gs.forEach(function (g, seq) {
        if (blanksFirst && g.rk === 0) { head.push(g); return; }
        var t = bucket(g), p;
        if (t < 0) p = 500000 + seq; else { cnt[t] = (cnt[t] || 0) + 1; p = (cnt[t] - 1) * nb + t; }
        rest.push({ g: g, p: p });
      });
      rest.sort(function (a, b) { return a.p - b.p; });
      return head.concat(rest.map(function (x) { return x.g; }));
    }
    function views(pool) {
      /* a chip earns its place only when it narrows the page */
      var cnt = {}, total = ncards(pool), aud = { 0: 0, 1: 0 };
      pool.forEach(function (it) { if (it.g === 0) aud[0]++; else if (it.g === 1) aud[1]++; });
      VIEWS.forEach(function (v) { cnt[v[0]] = ncards(pool.filter(function (it) { return inView(it, v[0]); })); });
      var styles = VIEWS.filter(function (v) { return v[0].charAt(0) === 's' && cnt[v[0]] >= 2 && cnt[v[0]] < total; });
      return VIEWS.filter(function (v) {
        if (v[0] === st.view) return true;
        if (v[0].charAt(0) === 'a') return aud[0] > 0 && aud[1] > 0 && cnt[v[0]] < total;
        return styles.length >= 2 && styles.indexOf(v) > -1;
      }).map(function (v) { return { k: v[0], i: v[1], n: cnt[v[0]] || 0 }; });
    }
    function chip(attr, val, on, label, n, icon, cls) {
      return '<button type="button" class="fh-cat-chip' + (cls ? ' ' + cls : '') + '" ' + attr + '="' + esc(val) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + (icon || '') + esc(label) + ' <span class="fh-cat-n">' + n + '</span></button>';
    }
    function compute() {
      var b = base(), counts = { all: ncards(b) };
      famOrder.forEach(function (f) { counts[f] = ncards(b.filter(function (it) { return it.fam === f; })); });
      $$('[data-type]', typesEl).forEach(function (ch) {
        var t = ch.getAttribute('data-type'), n = counts[t] || 0;
        $('[data-n]', ch).textContent = n;
        ch.hidden = t !== 'all' && !n && st.type !== t;
        ch.setAttribute('aria-pressed', t === st.type ? 'true' : 'false');
      });
      /* hide the type row when every product is one type */
      var fams = famOrder.filter(function (k) { return counts[k] > 0; });
      typesEl.hidden = fams.length < 2 && st.type === 'all';
      var typed = st.type === 'all' ? b : b.filter(function (it) { return it.fam === st.type; });

      /* themes, and the second row under the picked one */
      var pool = typed, ti = -1, subs = [];
      if (TH.length) {
        if (st.theme && !TH.some(function (t) { return t.slug === st.theme; })) st.theme = '';
        TH.forEach(function (t, i) { if (t.slug === st.theme) ti = i; });
        var tc = {}; groups(typed).forEach(function (g) { tc[g.tix] = (tc[g.tix] || 0) + 1; });
        themesEl.innerHTML = (typesEl.hidden ? chip('data-theme', '', !st.theme, T.allLabel || 'All', ncards(typed)) : '') +
          TH.map(function (t, i) { return (tc[i] || i === ti) ? chip('data-theme', t.slug, i === ti, t.n, tc[i] || 0, ICS[t.ic]) : ''; }).join('');
        themesEl.hidden = false;
        if (ti > -1) { pool = typed.filter(function (it) { return it.tix === ti; }); subs = TH[ti].subs; }
      } else if (themesEl) { themesEl.innerHTML = ''; themesEl.hidden = true; }
      var si = -1;
      if (subs.length) {
        if (st.sub && !subs.some(function (x) { return x.slug === st.sub; })) st.sub = '';
        var sh = subs.map(function (x, i) {
          if (x.slug === st.sub) si = i;
          var n = ncards(pool.filter(function (it) { return hit(it, x.rules); }));
          return (n || x.slug === st.sub) ? chip('data-sub', x.slug, x.slug === st.sub, x.n, n, '', 'fh-cat-chip--sub') : '';
        }).join('');
        subsEl.innerHTML = sh; subWrap.hidden = !sh;
        if (si > -1) pool = pool.filter(function (it) { return hit(it, subs[si].rules); });
      } else { st.sub = ''; if (subsEl) { subsEl.innerHTML = ''; subWrap.hidden = true; } }

      /* shop-by chips on pages of one kind, or once a type is picked */
      var vs = (typesEl.hidden || st.type !== 'all') ? views(pool) : [];
      if (st.view && !vs.some(function (v) { return v.k === st.view; })) st.view = '';
      if (vs.length) {
        viewsEl.innerHTML = (typesEl.hidden && !TH.length ? chip('data-view', '', !st.view, T.allLabel || 'All', ncards(pool)) : '') +
          vs.map(function (v) { return chip('data-view', v.k, st.view === v.k, VL[v.k] || v.k.slice(2), v.n, ICS[v.i] || ''); }).join('');
        viewsEl.hidden = false;
      } else { viewsEl.innerHTML = ''; viewsEl.hidden = true; }
      rowEl.hidden = typesEl.hidden && viewsEl.hidden && (!themesEl || themesEl.hidden);
      sec.classList.toggle('fh-cat-norow', rowEl.hidden);

      var shownItems = st.view ? pool.filter(function (it) { return inView(it, st.view); }) : pool;
      var gs = groups(shownItems);
      if (st.sort === 'price-asc') list = gs.sort(function (x, y) { return x.it.p - y.it.p || x.i0 - y.i0; });
      else if (st.sort === 'price-desc') list = gs.sort(function (x, y) { return y.it.p - x.it.p || x.i0 - y.i0; });
      else if (st.sort === 'az') list = gs.sort(function (x, y) { return stripCol(split(x.it.t, x.it.b).name).localeCompare(stripCol(split(y.it.t, y.it.b).name)); });
      else {
        var bucket = null, nb = 0;
        if (mix && !st.q && !st.view) {
          if (TH.length && ti < 0) { bucket = function (g) { return g.tix; }; nb = TH.length; }
          else if (ti > -1 && subs.length && si < 0) { bucket = function (g) { return g.six; }; nb = subs.length; }
          else if (!TH.length && st.type === 'all') { bucket = function (g) { return g.fi; }; nb = famOrder.length; }
        }
        list = arrange(gs, bucket, nb);
      }
      /* size chips from the products left after the chips above */
      var szc = {};
      pool.filter(function (it) { return inView(it, st.view); }).forEach(function (it) { it.sz.forEach(function (z) { szc[z] = (szc[z] || 0) + 1; }); });
      var keys = Object.keys(szc).sort(function (a, b) { return a - b; });
      if (st.size && keys.indexOf(st.size) === -1) st.size = '';
      if (keys.length > 1) {
        sizesEl.innerHTML = keys.map(function (z) { return '<button type="button" class="fh-cat-chip fh-cat-chip--sm" data-size="' + z + '" aria-pressed="' + (st.size === z ? 'true' : 'false') + '">' + z + 'ml</button>'; }).join('');
        sizeWrap.hidden = false;
      } else { sizesEl.innerHTML = ''; sizeWrap.hidden = true; }
    }
    function status() {
      var total = list.length;
      statusEl.textContent = (T.status || '[shown] of [total] designs').replace('[shown]', Math.min(shown, total)).replace('[total]', total);
      clears.forEach(function (c) { if (!c.closest('[data-fh-empty]')) c.hidden = !active(); });
      emptyEl.hidden = total > 0;
      var rest = total - shown;
      moreWrap.hidden = rest <= 0;
      if (rest > 0) moreBtn.textContent = (T.moreN || 'Show [n] more').replace('[n]', Math.min(per, rest));
      if (meter) meter.style.width = (total ? Math.min(100, shown / total * 100) : 0) + '%';
      var nf = (st.size ? 1 : 0) + (st.price ? 1 : 0) + (st.sort !== 'featured' ? 1 : 0);
      if (fcount) fcount.textContent = nf ? String(nf) : '';
      if (fdone) fdone.textContent = total ? (T.showN || 'Show [n] designs').replace('[n]', total) : (T.showNone || 'No designs match');
    }
    function render(reset, animate) {
      if (reset) { shown = 0; grid.innerHTML = ''; }
      var from = shown, next = list.slice(shown, shown + per);
      var html = next.map(function (g, j) { g.sel = 0; return card(g.it, T, g, 0, from + j); }).join('');
      grid.insertAdjacentHTML('beforeend', html);
      shown += next.length;
      if (animate && !reduce) { grid.classList.remove('fh-cat-in'); void grid.offsetWidth; grid.classList.add('fh-cat-in'); }
      status();
    }
    /* after a change made from the docked row, bring the top of the grid back into view */
    function toGrid() {
      if (!dock) return;
      var top = headerBottom() + dock.offsetHeight + 8;
      var y = statusEl.getBoundingClientRect().top - top;
      if (y < -4) window.scrollTo({ top: window.pageYOffset + y, behavior: reduce ? 'auto' : 'smooth' });
    }
    function apply(fromRow) { if (!items) return; compute(); render(true, true); syncUrl(); if (fromRow) toGrid(); }

    /* a colour dot swaps the card to that version; the photo stays until the new one has loaded */
    grid.addEventListener('click', function (e) {
      var d = e.target.closest('[data-fh-dot]'); if (!d || !items) return;
      var art = d.closest('[data-g]'); if (!art) return;
      var gi = +art.getAttribute('data-g'), g = list[gi], j = +d.getAttribute('data-fh-dot');
      if (!g || !g.vs[j] || g.sel === j) return;
      g.sel = j;
      var box = document.createElement('div'); box.innerHTML = card(g.vs[j], T, g, j, gi);
      var nu = box.firstElementChild, oi = $('.fh-cc-media img', art), ni = $('.fh-cc-media img', nu);
      if (oi && ni) {
        ni.parentNode.replaceChild(oi, ni);
        oi.setAttribute('srcset', ni.getAttribute('srcset')); oi.setAttribute('src', ni.getAttribute('src'));
      }
      art.parentNode.replaceChild(nu, art);
      var f = $('[data-fh-dot="' + j + '"]', nu); if (f) f.focus({ preventScroll: true });
    });

    /* ------------------------------------------------------------------ phone panel */
    var lastFocus = null;
    function isSheet() { return phone.matches; }
    function openPanel() {
      if (!isSheet()) return;
      lastFocus = document.activeElement;
      sec.classList.add('fh-cat-open');
      ftog.setAttribute('aria-expanded', 'true');
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      scrim.hidden = false;
      document.documentElement.classList.add('fh-cat-lock');
      setTimeout(function () { var f = fclose || $('select, button', panel); if (f) f.focus({ preventScroll: true }); }, 40);
    }
    function closePanel(back) {
      if (!sec.classList.contains('fh-cat-open')) return;
      sec.classList.remove('fh-cat-open');
      ftog.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('role'); panel.removeAttribute('aria-modal');
      scrim.hidden = true;
      document.documentElement.classList.remove('fh-cat-lock');
      if (back !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    if (ftog) ftog.addEventListener('click', function () { if (sec.classList.contains('fh-cat-open')) closePanel(); else openPanel(); });
    if (fclose) fclose.addEventListener('click', function () { closePanel(); });
    if (scrim) scrim.addEventListener('click', function () { closePanel(); });
    if (fdone) fdone.addEventListener('click', function () { closePanel(false); toGrid(); ftog.focus({ preventScroll: true }); });
    panel.addEventListener('keydown', function (e) {
      if (!sec.classList.contains('fh-cat-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button:not([hidden]), select, input', panel).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    var onPhone = function () { if (!isSheet()) closePanel(false); };
    if (phone.addEventListener) phone.addEventListener('change', onPhone); else if (phone.addListener) phone.addListener(onPhone);

    /* ------------------------------------------------------------------ docked chip row */
    var ticking = false;
    function dockSync() {
      ticking = false;
      if (!dock) return;
      var hb = headerBottom();
      sec.style.setProperty('--fh-cat-top', hb + 'px');
      var r = dock.getBoundingClientRect();
      dock.classList.toggle('is-stuck', isSheet() && r.top <= hb + 1 && sec.getBoundingClientRect().top < hb);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(dockSync); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    dockSync();
    /* keep the picked chips in view inside their rows, clear of the fades */
    function chipIntoView() {
      [[rowEl, '[aria-pressed="true"]:not([data-type="all"]):not([data-view=""]):not([data-theme=""])'], [subsEl, '[aria-pressed="true"]']].forEach(function (p) {
        var row = p[0]; if (!row || row.hidden) return;
        var on = $(p[1], row); if (!on) return;
        var rr = row.getBoundingClientRect(), cr = on.getBoundingClientRect();
        if (cr.right > rr.right - 48 || cr.left < rr.left + 48) {
          var x = cr.left - rr.left + row.scrollLeft - 56;
          row.scrollTo({ left: Math.max(0, x), behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    }

    typesEl.addEventListener('click', function (e) { var b = e.target.closest('[data-type]'); if (!b) return; st.type = b.getAttribute('data-type'); st.size = ''; st.view = ''; st.theme = ''; st.sub = ''; apply(true); chipIntoView(); });
    if (themesEl) themesEl.addEventListener('click', function (e) { var b = e.target.closest('[data-theme]'); if (!b) return; var v = b.getAttribute('data-theme'); st.theme = st.theme === v ? '' : v; st.sub = ''; st.view = ''; apply(true); chipIntoView(); });
    if (subsEl) subsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-sub]'); if (!b) return; var v = b.getAttribute('data-sub'); st.sub = st.sub === v ? '' : v; apply(true); chipIntoView(); });
    viewsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-view]'); if (!b) return; var v = b.getAttribute('data-view'); st.view = st.view === v ? '' : v; apply(true); chipIntoView(); });
    sizesEl.addEventListener('click', function (e) { var b = e.target.closest('[data-size]'); if (!b) return; var z = b.getAttribute('data-size'); st.size = st.size === z ? '' : z; apply(); });
    priceEl.addEventListener('change', function () { st.price = priceEl.value; apply(); });
    sortEl.addEventListener('change', function () { st.sort = sortEl.value; apply(); });
    var qt; qEl.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { st.q = qEl.value; apply(); }, 220); });
    qEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(qt); st.q = qEl.value; apply(); qEl.blur(); } });
    clears.forEach(function (c) { c.addEventListener('click', function () { st = { type: 'all', theme: '', sub: '', view: '', size: '', price: '', sort: st.sort, q: '' }; qEl.value = ''; priceEl.value = ''; apply(); chipIntoView(); }); });
    moreBtn.addEventListener('click', function () {
      var first = shown; render(false, false);
      var el = grid.children[first]; if (el) { var a = $('.fh-cc-name', el); if (a) a.focus({ preventScroll: true }); }
    });

    /* load the whole source, 250 a page */
    statusEl.textContent = T.loading || 'Loading every design…';
    var feed = src.replace(/\/$/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=fann-catalog-feed&page=';
    function page(n) {
      return fetch(feed + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var m = html.match(/<script type="application\/json" data-fh-catfeed>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : { pages: 1, items: [] };
      });
    }
    page(1).then(function (d1) {
      var rest = [];
      for (var n = 2; n <= Math.min(d1.pages || 1, 12); n++) rest.push(page(n));
      return Promise.all(rest).then(function (ds) { return [d1].concat(ds); });
    }).then(function (ds) {
      var seen = {}, all = [], kc = {};
      ds.forEach(function (d) { (d.items || []).forEach(function (it) { if (seen[it.h]) return; seen[it.h] = 1; if (hideBlanks && it.b) return; all.push(it); }); });
      all.forEach(function (it, i) {
        it.fam = fam(it); it.sz = sizes(it.t); it.i0 = i;
        it.g = it.g || 0; it.l = it.l || '';
        it.ts = '|' + (it.tg || []).join('|').toLowerCase() + '|';
        var li = LEAD.indexOf(String(it.ty || '').toLowerCase());
        it.rk = blanksFirst && it.b ? 0 : li > -1 ? li + 1 : LEAD.length + 1;
        if (it.fam !== 'other' && famOrder.indexOf(it.fam) < 0) famOrder.push(it.fam);
        it.fi = famOrder.indexOf(it.fam);
        it.tix = -1; it.six = -1;
        if (!it.b) for (var t = 0; t < TH.length; t++) if (hit(it, TH[t].rules)) { it.tix = t; break; }
        if (it.tix > -1) { var S = TH[it.tix].subs; for (var u = 0; u < S.length; u++) if (hit(it, S[u].rules)) { it.six = u; break; } }
        it.vk = '#' + i; it.vc = 'base';
        if (grp && !it.b) {
          var v = vkey(it), id = v.k + '|' + v.c;
          it.vk = kc[id] ? v.k + '#' + i : v.k; it.vc = v.c; kc[id] = 1;
        }
      });
      items = all;
      compute(); render(true, false); syncUrl(); chipIntoView();
      var pg = $('[data-fh-pages]', sec); if (pg) pg.remove();
      /* the hero's count pill counts sold-out products and every colour: show the cards the grid really holds */
      if (src.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) $$('[data-fh-total]').forEach(function (el) {
        var t = $('[data-fh-total-t]', el); if (t) t.textContent = el.getAttribute('data-fh-total').replace('[n]', ncards(items));
      });
    }).catch(function () {
      /* keep the server-rendered step and its "Next page" link */
      statusEl.textContent = '';
    });
  }

  function boot(scope) {
    $$('[data-fh-catalog]', scope || document).forEach(init);
    $$('[data-fh-scroller]', scope || document).forEach(scroller);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && $('[data-fh-catalog]', e.target); if (s) s.__fhCat = false;
    $$('[data-fh-scroller]', e.target).forEach(function (el) { el.__fhSc = false; });
    boot(e.target);
  });
})();
